import { GrLocation } from 'react-icons/gr'

import styles from './styles.module.scss'

import { Institution } from '@/domain/entities/institution.entity'
import { Course } from '@/domain/entities/course.entity'

interface IProps {
  institution: Institution
  course: Course
}

export const Map = ({ course, institution }: IProps) => {
  const isLargeSize = institution?.title?.length > 27
  return (
    <div className={styles.container}>
      {!isLargeSize && <h2 className={styles.title}>{institution?.title}</h2>}
      {isLargeSize && <h3 className={styles.title}>{institution?.title}</h3>}
      <p>
        <GrLocation />
        {institution?.bairro}
      </p>
      <iframe
        title={course?.name}
        src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDWRf5JjVw7MJr-hcsft3YWeqQ1r0TmYN4&q=${institution.title},+${institution.bairro},+${institution.cidade},+${institution.uf}`}
        className={styles.map}
        loading="lazy"
      />
    </div>
  )
}
